export default __webpack_public_path__ + "static/media/team2.b60a626a.jpeg";